var enviroment = process.env.NODE_ENV
console.log('enviroment', enviroment);
var configuration = {
    development: {
        iaccount: 'http://iaccount-dev.smartmice.cn',
        gateway: 'https://gateway-dev-k8s.smarteventcloud.cn',
        mark: "DEV"
    },
    production: {
        iaccount: 'https://iaccount-supplier.smartmice.cn',
        gateway: 'https://gateway.smartmice.cn',
        mark: "LIVE"
    }
}[enviroment];

export default configuration;
